module.exports = __webpack_public_path__ + "img/nudot.ef43edc4.png";